<template>
    <div @click="toggleLoginMenu">
        <TotemRouterLink
            class="totem-link login-menu"
            color="primary"
            :label="$t('Menu.login')"
            :fullWidth=true
            :loginMenu=true
            :to="{ name: 'login' }"
        />
    </div>

</template>

<script>
    export default {
        name: 'totem-router-link-sidebar-login',
        methods: {
            toggleLoginMenu() {
                this.$store.dispatch('toggleSidebar')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .totem-link {
        &.login-menu {
            display: flex;
            width: 100%;
            height: 45px;
            align-items: center;
            justify-content: center;
            margin: 20px 0;
            padding: 0px 20px;
        }
    }
</style>
